module.exports = __webpack_public_path__ + "img/happybrain_bg.861377ed.jpg";